import { Component, Input } from '@angular/core'

@Component({
  selector: 'dmmp-shared-accordion',
  templateUrl: './accordion.component.html'
})
export class AccordionComponent {
  @Input() identifier
  @Input() class
  @Input() contentAccordion
}
